import { forwardRef, createElement, useEffect } from 'react';
import cn from 'classnames';
import { Icon as Icon$1 } from '../../Icon/Icon.js';
import { useCurrentMenu } from '../Context.js';
import { Item as Item$1 } from '@radix-ui/react-dropdown-menu';

const Icon = ({
  name
}) => createElement("span", {
  className: "absolute left-0 ml-1"
}, createElement(Icon$1, {
  className: "-ml-px -mt-px !h-5 !w-5",
  name: name
}));
const useItemStyling = ({
  disabled,
  indented,
  className
}) => {
  const menu = useCurrentMenu();
  useEffect(() => {
    if (indented && !(menu !== null && menu !== void 0 && menu.indented)) {
      menu === null || menu === void 0 ? void 0 : menu.registerIndentation();
    }
  }, [indented]);
  return cn('flex items-center justify-start h-8 pr-1.5 relative rounded w-full focus:outline-none group', 'text-black aria-disabled:text-grey hover:bg-grey-light hover:text-black', {
    'pl-7': menu === null || menu === void 0 ? void 0 : menu.indented,
    'pl-1.5': !(menu !== null && menu !== void 0 && menu.indented),
    'cursor-pointer': !disabled,
    'cursor-not-allowed': disabled
  }, className);
};
const Shortcut = props => {
  return createElement("span", Object.assign({}, props, {
    className: "text-grey-darkest ml-auto pl-3"
  }));
};
const Item = /*#__PURE__*/forwardRef(function MenuItem(props, ref) {
  var _props$disabled;

  const {
    dialog,
    icon,
    onClick,
    shortcut,
    ...otherProps
  } = props;
  const className = useItemStyling({
    disabled: props.disabled,
    indented: !!icon,
    className: props.className
  });
  const disabled = (_props$disabled = props.disabled) !== null && _props$disabled !== void 0 ? _props$disabled : props['aria-disabled'];
  let handleClick; // radix has a bug that does not disable clicks when disabled is set on items

  if (disabled) {
    handleClick = event => {
      event.preventDefault();
      event.stopPropagation();
    };
  }

  const handleSelect = event => {
    if (onClick) {
      onClick(event);
    }

    if (props['aria-haspopup'] || typeof dialog === 'function') {
      event.preventDefault();
    }
  };

  let button = createElement(Item$1, Object.assign({}, otherProps, {
    className: className,
    onClick: handleClick,
    onSelect: handleSelect,
    ref: ref
  }), icon && createElement(Icon, {
    name: icon
  }), props.children, shortcut && createElement(Shortcut, null, shortcut));

  if (typeof dialog === 'function') {
    button = dialog({
      trigger: button
    });
  }

  return button;
});

export { Icon, Item, Shortcut, useItemStyling };
//# sourceMappingURL=Item.js.map
